import { forwardRef, memo } from 'react';

function forwardRefWithAs(render) {
  return forwardRef(render);
}
function memoWithAs(Component, propsAreEqual) {
  return memo(Component, propsAreEqual);
}

export { forwardRefWithAs, memoWithAs };
//# sourceMappingURL=index.esm.js.map
